export default class EditTeacherAccountController {
    // @ngInject
    constructor(targetUser, schoolId, schoolName) {
        this.targetUser = targetUser;
        this.schoolId = schoolId;
        this.schoolName = schoolName;
    }
}
